import { useBlocNext } from "@blac/react";
import styled from "@emotion/styled";
import type { ComponentProps, FC } from "react";
import React, { useEffect } from "react";
import SignupCustomIneligibility from "src/ui/components/SignupCustomContent/SignupCustomIneligibility";
import ClinicalExceptionCubit from "src/ui/components/SignupCustomContent/state/ClinicalExceptionCubit";
import Translate from "src/ui/components/Translate/Translate";

const OfferText = styled.p`
  max-width: 380px;
  margin: 0 auto;
`;

export const ClinicalExceptionOfferText: FC = () => {
  const [{ requested }] = useBlocNext(ClinicalExceptionCubit);
  const message = requested
    ? "ineligibility.exceptionOffer.requested"
    : "ineligibility.exceptionOffer.description";

  return (
    <OfferText className="color-c-80">
      <Translate msg={message} />
    </OfferText>
  );
};

/** Ineligibility screen whose "Request Exception" action is hidden once the member has an active exception. */
export const ClinicalExceptionIneligibility: FC<
  Omit<ComponentProps<typeof SignupCustomIneligibility>, "primaryAction">
> = (props) => {
  const [
    { requested, submitting },
    { loadRequestedException, requestException }
  ] = useBlocNext(ClinicalExceptionCubit);

  useEffect(() => {
    void loadRequestedException();
  }, [loadRequestedException]);

  const primaryAction = requested
    ? undefined
    : {
        label: <Translate msg="ineligibility.exceptionOffer.button" />,
        onPress: () => void requestException(),
        isDisabled: submitting
      };

  return <SignupCustomIneligibility {...props} primaryAction={primaryAction} />;
};
